module.exports = __webpack_public_path__ + "img/index-section7-award202501.e45dc121.png";